module.exports = require("core-js-pure/stable/instance/flat");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/instance/flat.js
// module id = 3469
// module chunks = 25